export function isCaptchaRequired(error: any): boolean {
  const response = error?.response
  if (!response || response.status !== 401) {
    return false
  }

  const header = response.headers?.['x-captcha'] ?? response.headers?.['X-CAPTCHA']
  if (String(header || '').toLowerCase() === 'required') {
    return true
  }

  return response.data?.message === 'captcha required'
}

export function getCaptchaSiteKey(error: any): string | null {
  const siteKey = error?.response?.data?.siteKey
  return typeof siteKey === 'string' && siteKey ? siteKey : null
}
